export default __webpack_public_path__ + "static/4-07fe59a132aff907fd5a82e6c54625b7.jpeg";